import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSeparator'
})
export class ThousandSeparatorPipe implements PipeTransform {

  transform(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    const parsedValue = Number(value);
    return parsedValue.toLocaleString('en-US');
  }

}
